export default class Assets {
    // IMAGES
    public static patternGold = require(`@/assets/images/pattern_gold.svg`);
    public static patternGrey = require(`@/assets/images/pattern_grey.svg`);
    public static bg = require(`@/assets/images/bg/2.png`);
    public static graph10 = require(`@/assets/images/graphs/10-20.png`);
    public static graph20 = require(`@/assets/images/graphs/20-30.png`);
    public static graph30 = require(`@/assets/images/graphs/30-40.png`);
    public static graph40 = require(`@/assets/images/graphs/40-50.png`);
    public static graph50 = require(`@/assets/images/graphs/50-60.png`);
    public static graph60 = require(`@/assets/images/graphs/60-70.png`);
    public static graph70 = require(`@/assets/images/graphs/70-80.png`);
}
